// @flow
import Box from "@mui/material/Box";
import { DataGridPremium } from "@mui/x-data-grid-premium";
import dayjs from "dayjs";
import { useMemo } from "react";
import PrintButton from "../../../../../components/mui/general/printButton/printButton";
import { CustomPagination } from "../../../../../components/mui/grids/dataGridCustom/customPagination";
import DataGridWrapper from "../../../../../components/mui/grids/dataGridWrapper/dataGridWrapper";
import { API } from "../../../../../helpers/constants";
import { muiGridLocales } from "../../../../../helpers/mui/muiLocales";
import TruncateDescription from "../../../../../pages/dashboard/partials/truncateDescription";

type Props = {

};

const Offers = (props: Props) => {
	const { data, language, dateFormat, timeFormat, t } = props
	const columns = useMemo(() => [
		{
			field: 'id',
			type: 'actions',
			width: 100,
			align: 'center',
			renderCell: (params) => {
				return (
					<PrintButton
						autoReloadFile={false}
						url={`${API}/en/custom/workOrder/attachment?name=${params.row.name}`}
						automaticallyUsePrintFile={true}
					/>
				)
			}
		},
		{
			field: 'name',
			headerName: t('File'),
			description: t('File'),
			minWidth: 200,
			flex: 1,
			renderCell: (params) => {
				return <TruncateDescription value={params.value}/>
			},
		},
		{
			field: 'sendDate',
			headerName: t('Send Date'),
			description: t('Send Date'),
			flex: 1,
			minWidth: 150,
			type: 'date',
			align: 'center',
			valueFormatter: (value, row, column, apiRef) => {
				return (value ? dayjs(value).format(`${dateFormat} ${timeFormat}`) : null)
			}
		},
		{
			field: 'recipients',
			headerName: t('Recipients'),
			flex: 1,
			minWidth: 200,
			renderCell: (params) => {
				return <TruncateDescription value={params.value}/>
			},
		},
		{
			field: 'status',
			headerName: t('Status'),
			description: t('Status'),
			minWidth: 100,
			flex: 1,
			align:  'center',
			renderCell: (params) => {
				return <Box>{t(params.value)}</Box>
			},
		},
		{
			field: 'actionDate',
			headerName: t('Status change date'),
			description: t('Status change date'),
			flex: 1,
			minWidth: 150,
			type: 'date',
			align: 'center',
			valueFormatter: (value, row, column, apiRef) => {
				return (value ? dayjs(value).format(`${dateFormat} ${timeFormat}`) : null)
			}
		},
		{
			field: 'repliedBy',
			headerName: t('Replied By'),
			description: t('Replied By'),
			flex: 1,
			minWidth: 150,
			align: 'center',
			renderCell: (params) => {
				return <TruncateDescription value={params.value}/>
			},
		},
	], [t, dateFormat])
	return (
		<DataGridWrapper height={'auto'}>
			<DataGridPremium
				columns={columns}
				initialState={{
					density: "compact",
					pagination: {
						paginationModel: { pageSize: 10 },
					},
					sorting: {
						sortModel: [{ field: 'sendDate', sort: 'desc' }],
					},
				}}
				rows={data}
				slots={{
					pagination: CustomPagination,
				}}
				localeText={muiGridLocales(language)}
				pagination
				pageSizeOptions={[5, 10, 15, 20]}
				disableColumnMenu
			/>
		</DataGridWrapper>
	);
};

export default Offers